import React from "react"
import ContentIcon from "./graphics/content_icon.svg"
import CreativeIcon from "./graphics/creative_icon.svg"
import MenuIcon from "./graphics/menu_icon.svg"
import MessagesIcon from "./graphics/messages_icon.svg"
import RepoIcon from "./graphics/repo_icon.svg"
import ReportsIcon from "./graphics/reports_icon.svg"
import ScreensIcon from "./graphics/screens_icon.svg"
import StudentIcon from "./graphics/student_icon.svg"
import UsersIcon from "./graphics/users_icon.svg"
import HomeIcon from "./graphics/home_icon.svg"
import ProviderIcon from "./graphics/provider_icon.svg"
import SettingsIcon from "./graphics/settings_icon.svg"
import {getGreetingsModalInfoText} from "./greetingsModalInfoText"
import {BodyTemplate, FooterTemplate, GreetingsTemplate, HeaderTemplate} from "./greetingsTemplates"
import {Portal} from "../../types/securityTypes"
import {i18n} from "../../i18n/i18n"

export const contentGreetings: GreetingsTemplate = {
    Header: ({greetingsModalType}) => (
        <HeaderTemplate
            title={i18n.t`greetings:content.title`}
            icon={ContentIcon}
            isBusiness={greetingsModalType === "BUSINESS"}
        />
    ),
    Body: ({greetingsModalType}) => (
        <BodyTemplate
            title={i18n.t`greetings:content.body_title`}
            text={getGreetingsModalInfoText()[Portal.Content][greetingsModalType || "BUSINESS"]}
        />
    ),
    FooterActions: ({onClose, openArticles}) => (
        <FooterTemplate onClose={onClose} openArticles={openArticles} />
    ),
}

export const creativeGreetings: GreetingsTemplate = {
    Header: ({greetingsModalType}) => (
        <HeaderTemplate
            title={i18n.t`greetings:creative.title`}
            icon={CreativeIcon}
            isBusiness={greetingsModalType === "BUSINESS"}
        />
    ),
    Body: () => (
        <BodyTemplate
            title={i18n.t`greetings:creative.body_title`}
            text={getGreetingsModalInfoText()[Portal.Creative]}
        />
    ),
    FooterActions: ({onClose, openArticles}) => (
        <FooterTemplate onClose={onClose} openArticles={openArticles} />
    ),
}

export const menuGreetings: GreetingsTemplate = {
    Header: ({greetingsModalType}) => (
        <HeaderTemplate
            title={i18n.t`greetings:menu.title`}
            icon={MenuIcon}
            isBusiness={greetingsModalType === "BUSINESS"}
        />
    ),
    Body: ({greetingsModalType}) => (
        <BodyTemplate
            title={i18n.t`greetings:menu.body_title`}
            text={getGreetingsModalInfoText()[Portal.Menu][greetingsModalType || "BUSINESS"]}
        />
    ),
    FooterActions: ({onClose, openArticles}) => (
        <FooterTemplate onClose={onClose} openArticles={openArticles} />
    ),
}

export const messagesGreetings: GreetingsTemplate = {
    Header: ({greetingsModalType}) => (
        <HeaderTemplate
            title={i18n.t`greetings:messages.title`}
            icon={MessagesIcon}
            isBusiness={greetingsModalType === "BUSINESS"}
        />
    ),
    Body: ({greetingsModalType}) => (
        <BodyTemplate
            title={i18n.t`greetings:messages.body_title`}
            text={getGreetingsModalInfoText()[Portal.Messages][greetingsModalType || "BUSINESS"]}
        />
    ),
    FooterActions: ({onClose, openArticles}) => (
        <FooterTemplate onClose={onClose} openArticles={openArticles} />
    ),
}

export const reportsGreetings: GreetingsTemplate = {
    Header: ({greetingsModalType}) => (
        <HeaderTemplate
            title={i18n.t`greetings:reports.title`}
            icon={ReportsIcon}
            isBusiness={greetingsModalType === "BUSINESS"}
        />
    ),
    Body: () => (
        <BodyTemplate
            title={i18n.t`greetings:reports.body_title`}
            text={getGreetingsModalInfoText()[Portal.Reports]}
        />
    ),
    FooterActions: ({onClose, openArticles}) => (
        <FooterTemplate onClose={onClose} openArticles={openArticles} />
    ),
}

export const repositoryGreetings: GreetingsTemplate = {
    Header: ({greetingsModalType}) => (
        <HeaderTemplate
            title={i18n.t`greetings:library.title`}
            icon={RepoIcon}
            isBusiness={greetingsModalType === "BUSINESS"}
        />
    ),
    Body: ({greetingsModalType}) => (
        <BodyTemplate
            title={i18n.t`greetings:library.body_title`}
            text={getGreetingsModalInfoText()[Portal.Repository][greetingsModalType || "BUSINESS"]}
        />
    ),
    FooterActions: ({onClose, openArticles}) => (
        <FooterTemplate onClose={onClose} openArticles={openArticles} />
    ),
}

export const screensGreetings: GreetingsTemplate = {
    Header: ({greetingsModalType}) => (
        <HeaderTemplate
            title={i18n.t`greetings:screens.title`}
            icon={ScreensIcon}
            isBusiness={greetingsModalType === "BUSINESS"}
        />
    ),
    Body: () => (
        <BodyTemplate
            title={i18n.t`greetings:screens.body_title`}
            text={getGreetingsModalInfoText()[Portal.Screens]}
        />
    ),
    FooterActions: ({onClose, openArticles}) => (
        <FooterTemplate onClose={onClose} openArticles={openArticles} />
    ),
}

export const studentGreetings: GreetingsTemplate = {
    Header: ({greetingsModalType}) => (
        <HeaderTemplate
            title={i18n.t`greetings:student.title`}
            icon={StudentIcon}
            isBusiness={greetingsModalType === "BUSINESS"}
        />
    ),
    Body: () => (
        <BodyTemplate
            title={i18n.t`greetings:student.body_title`}
            text={getGreetingsModalInfoText()[Portal.Student]}
            disclaimer={i18n.t`greetings:student.disclaimer`}
        />
    ),
    FooterActions: ({onClose, openArticles}) => (
        <FooterTemplate onClose={onClose} openArticles={openArticles} />
    ),
}

export const usersGreetings: GreetingsTemplate = {
    Header: ({greetingsModalType}) => (
        <HeaderTemplate
            title={i18n.t`greetings:users.title`}
            icon={UsersIcon}
            isBusiness={greetingsModalType === "BUSINESS"}
        />
    ),
    Body: () => (
        <BodyTemplate
            title={i18n.t`greetings:users.body_title`}
            text={getGreetingsModalInfoText()[Portal.Users]}
            disclaimer={i18n.t`greetings:users.disclaimer`}
        />
    ),
    FooterActions: ({onClose, openArticles}) => (
        <FooterTemplate onClose={onClose} openArticles={openArticles} />
    ),
}

export const homeGreetings: GreetingsTemplate = {
    Header: ({greetingsModalType}) => (
        <HeaderTemplate
            title={i18n.t`greetings:home.title`}
            icon={greetingsModalType === "BUSINESS" ? undefined : HomeIcon}
            isBusiness={greetingsModalType === "BUSINESS"}
        />
    ),
    Body: () => (
        <BodyTemplate
            title={i18n.t`greetings:home.body_title`}
            text={getGreetingsModalInfoText()[Portal.Home]}
        />
    ),
    FooterActions: ({onClose, openArticles}) => (
        <FooterTemplate onClose={onClose} openArticles={openArticles} />
    ),
}

export const providerGreetings: GreetingsTemplate = {
    Header: ({greetingsModalType}) => (
        <HeaderTemplate
            title={i18n.t`greetings:provider.title`}
            icon={ProviderIcon}
            isBusiness={greetingsModalType === "BUSINESS"}
        />
    ),
    Body: () => (
        <BodyTemplate
            title={i18n.t`greetings:provider.body_title`}
            text={getGreetingsModalInfoText()[Portal.Provider]}
        />
    ),
    FooterActions: ({onClose, openArticles}) => (
        <FooterTemplate onClose={onClose} openArticles={openArticles} />
    ),
}

export const settingsGreetings: GreetingsTemplate = {
    Header: ({greetingsModalType}) => (
        <HeaderTemplate
            title={i18n.t`greetings:settings.title`}
            icon={SettingsIcon}
            isBusiness={greetingsModalType === "BUSINESS"}
        />
    ),
    Body: () => (
        <BodyTemplate
            title={i18n.t`greetings:settings.body_title`}
            text={getGreetingsModalInfoText()[Portal.Settings]}
        />
    ),
    FooterActions: ({onClose, openArticles}) => (
        <FooterTemplate onClose={onClose} openArticles={openArticles} />
    ),
}

const defaultValue: GreetingsTemplate = {
    Header: () => null,
    Body: () => null,
    FooterActions: () => null,
}

export const getGreetingsModalContent = (portal: Portal): GreetingsTemplate | undefined => {
    switch (portal) {
        case Portal.Content:
            return contentGreetings
        case Portal.Creative:
            return creativeGreetings
        case Portal.Menu:
            return menuGreetings
        case Portal.Messages:
            return messagesGreetings
        case Portal.Reports:
            return reportsGreetings
        case Portal.Repository:
            return repositoryGreetings
        case Portal.Screens:
            return screensGreetings
        case Portal.Student:
            return studentGreetings
        case Portal.Users:
            return usersGreetings
        case Portal.Home:
            return homeGreetings
        case Portal.Provider:
            return providerGreetings
        case Portal.Settings:
            return settingsGreetings

        default:
            return defaultValue
    }
}
